import { useEffect, useRef } from 'react'
import useSeatmapStore from '../../../../../../../../../stores/seatmapStore'
import { OfferTooltip } from './OfferTooltip'
import { PriceTooltip } from './PriceTooltip'
import { SeatOfferTooltip } from './SeatOfferTooltip'
import { SeatTooltip } from './SeatTooltip'

export default function TooltipWrapper({ dialogRef, tooltipState }) {
  /** ::after arrow uses border-width 7.5px; tip sits ~7.5px below dialog box. */
  const ARROW_BELOW_BOX_PX = 8
  const lastPlacedTargetRef = useRef(null)
  const seatLookupTable = useSeatmapStore((state) => state.seatLookupTable)
  const seatOffersLookupTable = useSeatmapStore(
    (state) => state.seatOffersLookupTable
  )
  const sectionLookupTable = useSeatmapStore(
    (state) => state.sectionLookupTable
  )

  const renderTooltipContent = (tooltipState) => {
    const targetIsSeat = seatLookupTable[tooltipState.targetId]
    const seatOffers = seatOffersLookupTable[tooltipState.targetId]
    const hasMultipleOffers = seatOffers?.length > 1
    const targetIsSection = sectionLookupTable[tooltipState.targetId]
    const isMobile = window.innerWidth <= 768

    if (targetIsSeat) {
      if (hasMultipleOffers) {
        return (
          <SeatOfferTooltip
            target={seatOffers}
            seatId={tooltipState.targetId}
          />
        )
      }
      if (isMobile) {
        return <SeatTooltip showFullSeatTip={true} target={targetIsSeat} />
      } else {
        return <PriceTooltip target={targetIsSeat} />
      }
    }

    if (targetIsSection) {
      return <OfferTooltip target={targetIsSection} />
    }
  }

  useEffect(() => {
    const el = dialogRef.current
    if (!el) return

    if (!tooltipState.targetId) {
      lastPlacedTargetRef.current = null
      return
    }

    const margin = 8
    const place = () => {
      const rect = el.getBoundingClientRect()
      if (rect.width <= 0 || rect.height <= 0) return false
      const vw = window.innerWidth
      const vh = window.innerHeight
      const { clientX, clientY } = tooltipState.position
      const visualH = rect.height + ARROW_BELOW_BOX_PX
      let leftPos = clientX - rect.width / 2
      // Tip of arrow at clientY (rect excludes ::after, so subtract arrow extent).
      let topPos = clientY - rect.height - ARROW_BELOW_BOX_PX
      leftPos = Math.max(margin, Math.min(leftPos, vw - rect.width - margin))
      topPos = Math.max(margin, Math.min(topPos, vh - visualH - margin))
      el.style.left = `${leftPos}px`
      el.style.top = `${topPos}px`
      return true
    }

    const isNewTarget = lastPlacedTargetRef.current !== tooltipState.targetId
    lastPlacedTargetRef.current = tooltipState.targetId

    if (isNewTarget) {
      el.style.visibility = 'hidden'
      el.style.display = 'block'
      requestAnimationFrame(() => {
        const reveal = () => {
          el.style.visibility = ''
          el.style.display = ''
          el.show()
        }
        if (!place()) {
          requestAnimationFrame(() => {
            place()
            reveal()
          })
        } else {
          reveal()
        }
      })
    } else {
      requestAnimationFrame(() => {
        place()
      })
    }
  }, [tooltipState])

  return (
    <dialog
      ref={dialogRef}
      className={`vjx-tooltipWrapper seatmapTooltipArrow ${tooltipState.position.vertical + '--' + tooltipState.position.horizontal}`}
    >
      {renderTooltipContent(tooltipState)}
    </dialog>
  )
}
